/* ============================================================================
   UMAI PDP redesign — self-contained behavior for sections/product-umai.liquid
   Deliberately does NOT use theme.js product-template bindings; the section
   omits data-section-type="product-template" so theme.js ignores it.
   Add-to-cart posts to /cart/add.js via fetch — the custom UMAI cart drawer
   (snippets/cart-drawer.liquid) monkey-patches fetch and auto-opens itself,
   so no drawer wiring is needed here.
   ========================================================================== */
(function () {
  'use strict';

  /* translated strings (window.UMAI_I18N via snippets/umai-i18n.liquid);
     falls back to the English literal when a key or the bridge is missing */
  var I18N = window.UMAI_I18N || {};
  function tr(k, fb) { return I18N[k] || fb; }

  function formatMoney(cents) {
    /* the [data-variants] JSON prices are presentment-currency cents — format
       with the ACTIVE currency. theme.moneyFormat is the shop's USD template,
       so a size tap used to rewrite a €/¥/zł page's price row, pay-4 line,
       ATC label and sticky price as "$34.99". Same approach as the cart
       drawer's money(). */
    var cur = (window.Shopify && window.Shopify.currency) || {};
    if (cur.active && cur.active !== 'USD') {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active }).format(cents / 100); } catch (e) {}
    }
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    // strip HTML the money_format sometimes carries, then substitute
    return fmt.replace(/<[^>]+>/g, '').replace(/\{\{\s*amount[^}]*\}\}/, amount).trim();
  }

  function init(root) {
    var variants;
    try {
      variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    } catch (e) { return; }

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var pay4El = root.querySelector('[data-pay4]');
    var atcBtn = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var hint = root.querySelector('[data-hint]');
    var errBox = root.querySelector('[data-cart-errors]');
    var form = root.querySelector('form[action*="/cart/add"]');
    /* sticky bar lives as a sibling after the section */
    var stickyBar = document.querySelector('[data-up-sticky]');
    var stickyPrice = stickyBar && stickyBar.querySelector('[data-sticky-price]');
    var plusCheck = root.querySelector('[data-plus-check]'); /* UMAI+ attach checkbox under ATC */
    var stickyVariant = stickyBar && stickyBar.querySelector('[data-sticky-variant]');
    var stickyAtcBtn = stickyBar && stickyBar.querySelector('[data-sticky-atc]');
    var stickyAtcText = stickyBar && stickyBar.querySelector('[data-sticky-atc-text]');
    var ctaRow = root.querySelector('.up-ctarow');

    /* ---- UMAI+ checkbox: two-way cart sync ----
       The box mirrors membership-in-cart on EVERY product page: checked when
       UMAI+ is in the bag (dataset.incart marks that state so a background
       cart refresh never clobbers a user's pending tick), and UNCHECKING a
       checked-because-in-cart box removes the membership from the cart.
       Checking while not in cart stays deferred — the add rides the next
       Add to Cart (see doAdd). */
    /* membership = monthly OR yearly product (inveterate-subscription /
       inveterate-subscription-1) — prefix match covers both */
    function isPlusHandle(h) { return !!h && h.indexOf('inveterate-subscription') === 0; }
    function syncPlus(c) {
      if (!plusCheck) return;
      var inCart = ((c && c.items) || []).some(function (it) { return isPlusHandle(it.handle); });
      if (inCart) { plusCheck.checked = true; plusCheck.dataset.incart = '1'; }
      else if (plusCheck.dataset.incart) { delete plusCheck.dataset.incart; plusCheck.checked = false; }
    }
    if (plusCheck) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(syncPlus).catch(function () {});
      /* the cart drawer fires cart:updated after every fetch/mutation */
      var plusSyncT = null;
      document.addEventListener('cart:updated', function () {
        clearTimeout(plusSyncT);
        plusSyncT = setTimeout(function () {
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); }).then(syncPlus).catch(function () {});
        }, 250);
      });
      /* one-tap join succeeded elsewhere on the page (gate banner / unlock
         panel) — reflect it immediately, no refetch dependency */
      document.addEventListener('umaiplus:added', function () {
        clearTimeout(plusSyncT);
        plusCheck.checked = true; plusCheck.dataset.incart = '1';
      });
      plusCheck.addEventListener('change', function () {
        if (plusCheck.checked || !plusCheck.dataset.incart) return; /* deferred add — nothing to do yet */
        /* unchecked while the membership is in the cart -> remove it */
        plusCheck.disabled = true;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var line = (c.items || []).find(function (it) { return isPlusHandle(it.handle); });
            if (!line) return null;
            /* cascade: removing UMAI+ also removes members-only exclusives —
               access leaves with the key. One atomic /cart/update.js keyed by
               line keys (sequential change.js gets dropped by Shopify's cart
               lock after a subscription-line removal). */
            var updates = {}; updates[line.key] = 0;
            (c.items || []).forEach(function (it) {
              if (!isPlusHandle(it.handle) && /exclusive/i.test(it.product_title || '')) updates[it.key] = 0;
            });
            return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
          })
          .then(function () { delete plusCheck.dataset.incart; plusCheck.disabled = false; document.dispatchEvent(new CustomEvent('cart:refresh')); })
          .catch(function () { plusCheck.disabled = false; plusCheck.checked = true; });
      });
    }

    /* selection state: option index (1-based) -> value. "Size" starts unpicked
       so the buyer makes an explicit choice (FN pattern); other options keep
       the server-selected default. */
    var sel = {};
    optionGroups.forEach(function (g) {
      var idx = +g.dataset.index;
      var pre = g.querySelector('[aria-pressed="true"]');
      if (pre) sel[idx] = pre.dataset.value;
    });

    function allPicked() {
      return optionGroups.every(function (g) { return sel[+g.dataset.index] != null; });
    }
    function currentVariant() {
      if (!allPicked()) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 1; k <= optionGroups.length; k++) {
          if (v['option' + k] !== sel[k]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function refresh() {
      var v = currentVariant();
      /* price preview: exact variant if fully picked, else cheapest matching the picks so far */
      var pool = variants.filter(function (x) {
        for (var k = 1; k <= optionGroups.length; k++) {
          if (sel[k] != null && x['option' + k] !== sel[k]) return false;
        }
        return true;
      });
      /* keep the compare-at strikethrough when no variant is fully picked (the
         load state for every sized product) — use the cheapest matching
         variant's compare_at, mirroring the server-rendered markup. Losing the
         strikethrough on load hid the discount anchor sitewide. */
      var priceRef = v || (pool.length ? pool.reduce(function (a, b) { return b.price < a.price ? b : a; }) : null);
      var priceCents = priceRef ? priceRef.price : null;
      if (priceCents != null) {
        /* no literal space before .was — the gap is the span's margin alone, so
           the JS re-render matches the server-rendered spacing exactly */
        priceEl.innerHTML = formatMoney(priceCents) +
          (priceRef.compare_at_price > priceRef.price ? '<span class="was num">' + formatMoney(priceRef.compare_at_price) + '</span><span class="compv">Comp. Value</span>' : '');
        if (pay4El) pay4El.textContent = formatMoney(Math.round(priceCents / 4));
        if (stickyPrice) stickyPrice.textContent = formatMoney(priceCents);
        /* (the sale badge under ADD TO BAG carries no price — it states the
           percentage only, so nothing here reprices on variant change) */
        /* (the UMAI+ row's right column is the static trial price now —
           "$0 today / then $10/mo" — so nothing membership-side repricies
           on variant change anymore) */
      }
      if (stickyVariant) {
        /* only show the variant label once everything (incl. size) is chosen */
        var picks = optionGroups.map(function (g) { return sel[+g.dataset.index]; });
        stickyVariant.textContent = allPicked() ? picks.filter(Boolean).join(' / ') : tr('pdp_select_size', 'Select size');
      }
      if (v) {
        idInput.value = v.id;
        if (!v.available) {
          atcText.textContent = tr('pdp_sold_out', 'Sold out');
          atcBtn.disabled = true;
        } else {
          atcText.textContent = tr('pdp_add_to_bag', 'Add to Bag') + ' — ' + formatMoney(v.price);
          atcBtn.disabled = false;
        }
      } else {
        atcText.textContent = tr('pdp_add_to_bag', 'Add to Bag') + (priceCents != null ? ' — ' + formatMoney(priceCents) : '');
        atcBtn.disabled = false;
      }
      /* mirror sold-out onto the sticky bar — it was a silent dead button */
      if (stickyAtcBtn) {
        var soldOut = !!(v && !v.available);
        stickyAtcBtn.disabled = soldOut;
        if (stickyAtcText) stickyAtcText.textContent = soldOut ? tr('pdp_sold_out', 'Sold out') : tr('pdp_add_to_bag', 'Add to Bag');
      }
      /* per-value availability strike: value is oos if no available variant matches it plus the OTHER picks */
      optionGroups.forEach(function (g) {
        var idx = +g.dataset.index;
        g.querySelectorAll('.up-sz').forEach(function (b) {
          var any = variants.some(function (x) {
            if (!x.available) return false;
            if (x['option' + idx] !== b.dataset.value) return false;
            for (var k = 1; k <= optionGroups.length; k++) {
              if (k !== idx && sel[k] != null && x['option' + k] !== sel[k]) return false;
            }
            return true;
          });
          b.classList.toggle('oos', !any);
        });
      });
    }

    /* media index (0-based) of the image assigned to the variant that matches
       the current picks — used to swap the gallery to the chosen colour's photo.
       variant.featured_image.position is 1-based into product.media, and the
       gallery slides/thumbs are data-v="{{ forloop.index0 }}", so subtract 1.
       Returns null when no matching variant has an assigned image. */
    function variantMediaIndex() {
      for (var i = 0; i < variants.length; i++) {
        var x = variants[i], ok = true;
        for (var k = 1; k <= optionGroups.length; k++) {
          if (sel[k] != null && x['option' + k] !== sel[k]) { ok = false; break; }
        }
        if (ok && x.featured_image && x.featured_image.position) return x.featured_image.position - 1;
      }
      return null;
    }

    optionGroups.forEach(function (g) {
      var idx = +g.dataset.index;
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.up-sz');
        if (!b) return;
        sel[idx] = b.dataset.value;
        g.querySelectorAll('.up-sz').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var lbl = root.querySelector('[data-optname="' + idx + '"]');
        if (lbl) lbl.textContent = b.dataset.value;
        if (hint) hint.hidden = true;
        refresh();
        /* clicking a colour swaps the gallery to that colour's photo */
        if (/colou?r/i.test(g.dataset.name || '')) {
          var mi = variantMediaIndex();
          if (mi != null) setView(mi);
        }
      });
    });

    /* ---- add to cart: AJAX so the UMAI drawer's fetch hook opens it ---- */
    function doAdd() {
      errBox.textContent = '';
      if (!allPicked()) {
        var unpicked = optionGroups.filter(function (g) { return sel[+g.dataset.index] == null; })[0];
        if (hint) {
          hint.hidden = false;
          hint.textContent = 'Please select a ' + (unpicked.dataset.name || 'size').toLowerCase() + ' first';
        }
        unpicked.classList.remove('flash'); void unpicked.offsetWidth; unpicked.classList.add('flash');
        unpicked.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var v = currentVariant();
      if (!v || !v.available) return;
      /* in-flight guard: a fast double-click used to fire two adds AND capture
         orig as "Adding…" on the second pass, leaving the label stuck forever */
      if (doAdd._busy) return;
      doAdd._busy = true;
      atcBtn.disabled = true;
      if (stickyAtcBtn) stickyAtcBtn.disabled = true;
      var orig = atcText.textContent;
      var stickyOrig = stickyAtcText ? stickyAtcText.textContent : '';
      /* drive the sticky bar's ADD button in lockstep with the main one — the
         sticky bar is often the ONLY CTA on screen, so tapping it must show its
         own Adding…/✓ Added state (the confirmation used to fire off-screen). */
      var setLabel = function (label) { atcText.textContent = label; if (stickyAtcText) stickyAtcText.textContent = label; };
      var setAdded = function (on) { atcBtn.classList.toggle('is-added', on); if (stickyAtcBtn) stickyAtcBtn.classList.toggle('is-added', on); };
      var settle = function () { atcText.textContent = orig; if (stickyAtcText) stickyAtcText.textContent = stickyOrig; atcBtn.disabled = false; if (stickyAtcBtn) stickyAtcBtn.disabled = false; doAdd._busy = false; };
      setLabel('Adding…');
      /* UMAI+ attach checkbox: ride the membership (with its selling plan) in
         the SAME add call — one drawer refresh. The cart is checked first so a
         second checked ATC can never add a 2nd subscription; if that check
         itself fails, we skip the attach rather than risk a double-bill. */
      var wantPlus = plusCheck && plusCheck.checked;
      var preCheck = wantPlus
        ? fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) { return (c.items || []).some(function (it) { return isPlusHandle(it.handle); }); })
            .catch(function () { return true; })
        : Promise.resolve(true);
      var addOnce = function (includePlus) {
        var items = [{ id: v.id, quantity: 1 }];
        if (includePlus) items.push({ id: 40141956808838, quantity: 1, selling_plan: 849150086 });
        return fetch(((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      };
      preCheck.then(function (alreadyHasPlus) {
        var withPlus = wantPlus && !alreadyHasPlus;
        return addOnce(withPlus).then(function (r) {
          /* the membership attach must never cost the product sale: if the
             combined add failed for ANY reason, retry the tee alone before
             reporting an error (the cart band re-offers UMAI+ anyway) */
          if (!r.ok && withPlus) return addOnce(false);
          return r;
        });
      }).then(function (r) {
        /* read failures as TEXT first — error responses can carry empty or
           non-JSON bodies (proxy 429s, expired preview sessions), and calling
           r.json() there leaked "Unexpected end of JSON input" verbatim into
           the on-page error box */
        if (!r.ok) return r.text().then(function (t) {
          var msg = '';
          try { var j = JSON.parse(t); msg = (j && typeof j.description === 'string') ? j.description : ''; } catch (e2) {}
          throw new Error(msg || tr('pdp_add_error', 'Could not add to bag — please try again.'));
        }, function () { throw new Error(tr('pdp_add_error', 'Could not add to bag — please try again.')); });
        setLabel('✓ Added');
        setAdded(true);  /* brief green success pop on BOTH buttons */
        atcBtn.disabled = false;
        if (stickyAtcBtn) stickyAtcBtn.disabled = false;
        doAdd._busy = false;
        updateB2G();  /* advance the Buy-2-Get-1 bar now this tee is in the cart */
        setTimeout(function () { if (atcText.textContent === '✓ Added') { atcText.textContent = orig; if (stickyAtcText) stickyAtcText.textContent = stickyOrig; setAdded(false); } }, 1400);
      }).catch(function (err) {
        settle();
        errBox.textContent = (err && err.message && err.message.length < 200) ? err.message : tr('pdp_add_error', 'Could not add to bag — please try again.');
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(); });

    /* ---- Buy-2-Get-1 progress bar (tees only) — seeded from the LIVE cart so it
       reflects tees already in the bag, mirroring the cart/drawer ladder. ---- */
    var b2gEl = root.querySelector('[data-up-b2g]');
    var b2gLabel = b2gEl && b2gEl.querySelector('[data-up-b2g-label]');
    var b2gCount = b2gEl && b2gEl.querySelector('[data-up-b2g-count]');
    var b2gFill = b2gEl && b2gEl.querySelector('[data-up-b2g-fill]');
    var b2gNote = b2gEl && b2gEl.querySelector('[data-up-b2g-note]');
    function b2gIsTee(it) { var t = it.product_title || it.title || ''; return /T-Shirt/i.test(t) && !/Oversized/i.test(t); }
    /* copy/threshold come from window.UMAI_OFFER (snippets/umai-offer.liquid) */
    function b2gRender(tees) {
      if (!b2gEl) return;
      var s = (window.UMAI_OFFER && window.UMAI_OFFER.compute) ? window.UMAI_OFFER.compute(tees) : { count: '', pct: 0, unlocked: false, label: '', note: '' };
      b2gEl.classList.toggle('unlocked', s.unlocked);
      b2gCount.textContent = s.count;
      b2gFill.style.width = s.pct + '%';
      b2gLabel.textContent = s.label;
      if (b2gNote) { if (s.note) { b2gNote.textContent = s.note; b2gNote.hidden = false; } else { b2gNote.hidden = true; } }
    }
    function updateB2G() {
      if (!b2gEl) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { var t = 0; (c.items || []).forEach(function (it) { if (b2gIsTee(it)) t += it.quantity; }); b2gRender(t); })
        .catch(function () {});
    }
    if (b2gEl) {
      b2gRender(0);      /* synchronous initial state from the config (no stale flash) */
      updateB2G();       /* then refine with the real cart tee count */
      document.addEventListener('cart:refresh', updateB2G);
      document.addEventListener('cart:open', updateB2G);
      document.addEventListener('cart:updated', updateB2G);  /* drawer qty/remove */
    }

    /* ---- sticky add-to-cart bar: show when the main CTA row scrolls out ---- */
    if (stickyBar && ctaRow) {
      var stickyDismissed = false;
      var stickyAtc = stickyBar.querySelector('[data-sticky-atc]');
      if (stickyAtc) stickyAtc.addEventListener('click', function () {
        doAdd();
        if (!allPicked()) root.querySelector('.up-buy').scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
      var dismiss = stickyBar.querySelector('[data-sticky-dismiss]');
      if (dismiss) dismiss.addEventListener('click', function () {
        stickyDismissed = true; stickyBar.classList.remove('show'); stickyBar.setAttribute('aria-hidden', 'true');
        syncStickyPad();
      });
      /* reserve body space while the bottom bar is up so the footer's last rows
         (currency/language selectors) can scroll clear of it; the ≤767px bar
         anchors to the TOP, so no padding there */
      var syncStickyPad = function () {
        var pad = stickyBar.classList.contains('show') && window.matchMedia('(min-width:768px)').matches;
        document.body.style.paddingBottom = pad ? stickyBar.offsetHeight + 'px' : '';
      };
      window.addEventListener('resize', syncStickyPad, { passive: true });
      var onScroll = function () {
        var show = !stickyDismissed && ctaRow.getBoundingClientRect().bottom < 0;
        stickyBar.classList.toggle('show', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
        syncStickyPad();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      /* mirror the main countdown into the sticky proof line */
      var stickyCd = stickyBar.querySelector('[data-sticky-cd]');
      var mainCd = root.querySelector('[data-cd]');
      if (stickyCd && mainCd) {
        setInterval(function () { stickyCd.textContent = mainCd.textContent; }, 1000);
        stickyCd.textContent = mainCd.textContent;
      }
    }

    /* ---- gallery ---- */
    var views = root.querySelectorAll('.up-view');
    var thumbs = root.querySelectorAll('.up-th');
    var gcount = root.querySelector('[data-gcount]');
    /* non-first slides ship data-src only (stacked opacity:0 slides defeat
       native lazy-loading on desktop — every image downloaded at page load).
       Hydrate on view/swipe/hover, and prefetch the rest once the page is idle
       so thumb swaps stay instant without racing the LCP image. */
    function hydrate(i) {
      var v = root.querySelector('.up-view[data-v="' + i + '"]');
      var im = v && v.querySelector('img[data-src]');
      if (!im) return;
      im.sizes = im.dataset.sizes || '';
      im.srcset = im.dataset.srcset || '';
      im.src = im.dataset.src;
      im.removeAttribute('data-src');
    }
    var hydratedAll = false;
    function hydrateAll() {
      if (hydratedAll) return;
      hydratedAll = true;
      views.forEach(function (v) { hydrate(+v.dataset.v); });
    }
    if (window.requestIdleCallback) requestIdleCallback(hydrateAll, { timeout: 4000 });
    else setTimeout(hydrateAll, 2500);
    /* zoom is desktop-only state — clear it whenever the view changes, the
       carousel scrolls, or the viewport crosses the breakpoint, otherwise a
       zoomed image stays stuck scaled with no affordance to undo it */
    function clearZoom() {
      root.querySelectorAll('.up-view img.zoomed').forEach(function (im) { im.classList.remove('zoomed'); });
    }
    window.addEventListener('resize', clearZoom);
    function setView(i) {
      hydrate(i);
      clearZoom();
      views.forEach(function (v) { v.classList.toggle('on', +v.dataset.v === i); });
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(+t.dataset.v === i)); });
      if (gcount) gcount.textContent = i + 1;
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setView(+t.dataset.v); });
      /* FN behavior: on desktop, hovering a thumb IS the swap (setView
         hydrates first so the slide can't flash empty). >920 matches the
         carousel breakpoint; hover+fine-pointer keeps touch devices on the
         tap-to-swap path, where mouseenter still just prefetches. */
      t.addEventListener('mouseenter', function () {
        if (window.innerWidth > 920 && window.matchMedia('(hover: hover) and (pointer: fine)').matches) setView(+t.dataset.v);
        else hydrate(+t.dataset.v);
      });
    });
    root.querySelectorAll('.up-view img').forEach(function (im) {
      im.addEventListener('click', function (e) {
        /* <= 920 matches the CSS @media(max-width:920px) carousel — the old
           < 920 let desktop tap-zoom fire INSIDE the carousel at exactly 920 */
        if (window.innerWidth <= 920) return;
        if (im.classList.contains('zoomed')) { im.classList.remove('zoomed'); return; }
        var r = im.getBoundingClientRect();
        im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        im.classList.add('zoomed');
      });
    });
    var track = root.querySelector('[data-track]');
    var dots = root.querySelector('[data-dots]');
    if (track) track.addEventListener('touchstart', hydrateAll, { passive: true, once: true });
    if (track && dots) track.addEventListener('scroll', function () {
      hydrateAll(); /* no-op after first run — swipe intent means they want the rest */
      if (window.innerWidth > 920) return; /* > matches the CSS max-width:920 carousel (was >=, killing the dots at exactly 920) */
      var i = Math.round(track.scrollLeft / track.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
      if (gcount) gcount.textContent = i + 1;
    }, { passive: true });

    /* ---- countdown (weekly exclusive) + delivery date ---- */
    var cdEl = root.querySelector('[data-cd]');
    if (cdEl) {
      var endAttr = cdEl.dataset.end;
      var nextFriday = function () {
        var n = new Date();
        var t = new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()));
        var add = (5 - t.getUTCDay() + 7) % 7; if (add === 0) add = 7;
        t.setUTCDate(t.getUTCDate() + add); return t.getTime();
      };
      /* the metafield date is free-text like "June 7 2026 23:59"; Date.parse handles
         that in Chrome but Safari/iOS is stricter, so add comma + seconds as a fallback */
      var parseEnd = function (s) {
        var t = Date.parse(s);
        if (!isNaN(t)) return t;
        return Date.parse(String(s).replace(/^([A-Za-z]+)\s+(\d+)\s+(\d{4})\s+(\d{1,2}):(\d{2})/, '$1 $2, $3 $4:$5:00'));
      };
      var target = endAttr ? parseEnd(endAttr) : nextFriday();
      var cdBar = cdEl.closest('.up-cdbar');
      var hideCountdown = function () {
        /* the clock lives in the .up-cdbar strip under Add to Bag since
           2026-08-13; the `small` branch is the pre-move shipping-block line,
           kept so this stays correct if that markup ever comes back */
        if (cdBar) cdBar.hidden = true;
        else { var line = cdEl.closest('small'); if (line) line.style.display = 'none'; }
        /* the sticky bar is a SIBLING after the section (see the note at the top
           of init), so root.querySelector never found it — the sticky "removed
           in" line survived expiry forever. Query the document. */
        var sc = document.querySelector('[data-sticky-cd]'); if (sc) { var p2 = sc.closest('.p2') || sc; p2.style.display = 'none'; }
      };
      if (endAttr && (isNaN(target) || target <= Date.now())) {
        /* explicit exclusive end date that's invalid or already passed:
           hide the countdown line + sticky chip instead of showing a dead 00:00:00 */
        hideCountdown();
      } else {
        if (isNaN(target)) target = nextFriday();
        /* the date is live, so the strip may finally show — it renders hidden
           precisely so a stale date can never flash a countdown before this
           runs and takes it away again */
        var cdFill = cdBar && cdBar.querySelector('[data-up-cdbar-fill]');
        /* drop window = published_at -> deadline. Hand-entered end dates drift
           (and a re-published product resets published_at), so anything that
           does not describe a window ending in the future falls back to a
           7-day run — the actual cadence of the weekly drop. */
        var cdStart = 0;
        if (cdBar) {
          cdStart = (parseInt(cdBar.dataset.start, 10) || 0) * 1000;
          if (!cdStart || cdStart >= target) cdStart = target - 7 * 86400000;
          cdBar.hidden = false;
        }
        var pad = function (x) { return (x < 10 ? '0' : '') + x; };
        var tick = function () {
          var s = Math.max(0, Math.floor((target - Date.now()) / 1000));
          if (cdBar) {
            if (cdFill) cdFill.style.width = Math.max(0, Math.min(100, (target - Date.now()) / (target - cdStart) * 100)).toFixed(2) + '%';
            cdBar.classList.toggle('last', s <= 86400);
          }
          /* deadline passed while the page was open: hide, same as the
             load-time path — don't freeze at a dead "00:00:00" */
          if (s <= 0) { clearInterval(cdT); hideCountdown(); return; }
          var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
          cdEl.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(ss);
        };
        var cdT = setInterval(tick, 1000); tick();
      }
    }
    /* ---- delivery date + order-within cutoff (FN pattern) ----
       One daily cutoff anchored to US Eastern (the shop clock — a single global
       deadline for every shopper, not viewer-local, so the timer can't disagree
       with the date). Before the cutoff: "Get it by {+lead days}" and a green
       timer to today's cutoff. After it: the date rolls +1 day and the timer
       counts to TOMORROW's cutoff. Date and timer come from the SAME `missed`
       flag in the SAME render, recomputed from the wall clock every 30s (never
       decremented) — so at expiry both flip atomically, and tab sleep / midnight
       / DST self-heal on the next tick. */
    var delivEl = root.querySelector('[data-deliv]');
    if (delivEl) {
      var owEl = root.querySelector('[data-orderwin]');
      var leadDays = parseInt(delivEl.dataset.lead, 10) || 8;
      var cutoffSec = (parseFloat(delivEl.dataset.cutoff) || 16) * 3600;
      var etNowSec = function () {
        /* seconds since midnight in America/New_York; Intl handles DST.
           Falls back to viewer-local if the TZ database is unavailable. */
        try {
          var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour12: false, hour: 'numeric', minute: 'numeric', second: 'numeric' }).formatToParts(new Date());
          var o = {}; parts.forEach(function (p) { o[p.type] = parseInt(p.value, 10); });
          return (o.hour % 24) * 3600 + o.minute * 60 + (o.second || 0);
        } catch (e) {
          var n = new Date(); return n.getHours() * 3600 + n.getMinutes() * 60 + n.getSeconds();
        }
      };
      var renderDeliv = function () {
        var nowSec = etNowSec();
        var missed = nowSec >= cutoffSec;
        var dd = new Date(Date.now() + (leadDays + (missed ? 1 : 0)) * 86400000);
        delivEl.textContent = dd.toLocaleDateString(document.documentElement.lang || 'en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        if (owEl) {
          var left = (missed ? 86400 : 0) + cutoffSec - nowSec;
          var mins = Math.max(1, Math.ceil(left / 60)); /* floor at "1 min" — never a dead 0 */
          var h = Math.floor(mins / 60), m = mins % 60;
          owEl.textContent = (h > 0 ? h + ' ' + tr(h === 1 ? 'pdp_hr' : 'pdp_hrs', h === 1 ? 'hr' : 'hrs') + ' ' : '') + m + ' ' + tr(m === 1 ? 'pdp_min' : 'pdp_mins', m === 1 ? 'min' : 'mins');
        }
      };
      renderDeliv();
      setInterval(renderDeliv, 30000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) renderDeliv(); });
    }

    /* ---- description: the Station Tabs app rewrites product.description into
       its own tabset (the "broken tab"). We render from a clean JSON copy the
       app never sees, and re-assert it if the app injects its markup. ---- */
    var descIn = root.querySelector('[data-umai-desc]');
    var descJsonEl = root.querySelector('[data-umai-desc-json]');
    if (descIn && descJsonEl) {
      var cleanHtml = '';
      try { cleanHtml = JSON.parse(descJsonEl.textContent) || ''; } catch (e) {}
      var setDesc = function () { descIn.innerHTML = cleanHtml; };
      setDesc();
      var reasserting = false;
      var mo = new MutationObserver(function () {
        if (reasserting) return;
        if (descIn.querySelector('[class*="station-tabs"]')) {
          reasserting = true; setDesc();
          setTimeout(function () { reasserting = false; }, 0);
        }
      });
      mo.observe(descIn, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 4000);
    }

    /* ---- accordions ---- */
    root.querySelectorAll('.up-acch').forEach(function (h) {
      h.addEventListener('click', function (e) {
        /* stop app scripts (product-tab/accordion binders on document) from
           hijacking this click and opening their own tab UI */
        e.preventDefault();
        e.stopPropagation();
        var acc = h.parentElement, body = acc.querySelector('.up-accb');
        var open = acc.classList.toggle('open');
        h.setAttribute('aria-expanded', String(open));
        if (open) {
          body.style.maxHeight = body.scrollHeight + 'px';
        } else {
          /* closing from the settled 'none' state needs a px start for the
             transition to have something to animate from */
          if (body.style.maxHeight === 'none') { body.style.maxHeight = body.scrollHeight + 'px'; void body.offsetHeight; }
          body.style.maxHeight = '0';
        }
      });
      /* once the open transition settles, release the px cap — a fixed pixel
         max-height clipped the body on any later reflow (resize, late images,
         app-injected content) */
      var accEl = h.parentElement, bodyEl = accEl.querySelector('.up-accb');
      if (bodyEl) bodyEl.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'max-height' && accEl.classList.contains('open')) bodyEl.style.maxHeight = 'none';
      });
    });

    /* ---- size guide modal ---- */
    var sgm = root.querySelector('.up-sgm');
    if (sgm) {
      /* lock body scroll while the size guide is up — without it the page
         scrolled behind the modal on mobile (scroll chaining). closeSG fires on
         every Escape, so only release the lock if THIS modal was holding it. */
      var openSG = function () { sgm.classList.add('on'); document.body.style.overflow = 'hidden'; };
      var closeSG = function () { if (!sgm.classList.contains('on')) return; sgm.classList.remove('on'); document.body.style.overflow = ''; };
      root.querySelectorAll('[data-sg-open]').forEach(function (b) { b.addEventListener('click', openSG); });
      sgm.querySelector('.scrim').addEventListener('click', closeSG);
      sgm.querySelector('[data-sg-close]').addEventListener('click', closeSG);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSG(); });
      sgm.querySelectorAll('.up-unit button').forEach(function (b) {
        b.addEventListener('click', function () {
          var u = b.dataset.u;
          sgm.querySelectorAll('.up-unit button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          sgm.querySelectorAll('td[data-in]').forEach(function (td) { td.textContent = td.dataset[u]; });
        });
      });
    }

    /* ---- own star rating in the title: fetch Okendo aggregate, gold stars + count ---- */
    var ratingEl = root.querySelector('[data-up-rating]');
    if (ratingEl) {
      var sub = ratingEl.dataset.okeSub;
      if (sub) fetch('https://api.okendo.io/v1/stores/' + sub + '/review_aggregate', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var a = d.reviewAggregate || {};
          var count = a.ratingAndReviewCount || a.reviewCount || 0;
          var avg = count ? (a.ratingAndReviewValuesTotal / count) : 0;
          if (!count) { ratingEl.style.display = 'none'; return; } /* no real data -> don't show a fabricated rating */
          var avgEl = ratingEl.querySelector('[data-up-ravg]');
          var fillEl = ratingEl.querySelector('[data-up-rfill]');
          var cntEl = ratingEl.querySelector('[data-up-rcount]');
          if (avgEl) avgEl.textContent = avg.toFixed(1);
          if (fillEl) fillEl.style.width = (avg / 5 * 100).toFixed(1) + '%';
          if (cntEl) cntEl.textContent = '(' + count.toLocaleString() + ')';
          /* the block ships visibility:hidden (space reserved, no shift) so the
             hardcoded placeholder never paints — reveal only with real data */
          ratingEl.style.visibility = 'visible';
          /* keep the sticky-bar proof in sync with the same live number
             (the sticky bar renders outside the .umai-pdp root, so query the document) */
          var stickyR = document.querySelector('[data-sticky-review]');
          if (stickyR) stickyR.textContent = avg.toFixed(1) + ' — ' + count.toLocaleString() + ' verified reviews';
        }).catch(function () { ratingEl.style.display = 'none'; });
    }

    /* ---- share + wishlist (visual) ---- */
    var share = root.querySelector('[data-share]');
    if (share) share.addEventListener('click', function () {
      if (navigator.share) { navigator.share({ title: document.title, url: location.href }).catch(function () {}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(location.href);
        share.textContent = 'Link copied ✓';
        setTimeout(function () { share.innerHTML = 'Share <span aria-hidden="true">↗</span>'; }, 1500);
      }
    });
    /* wishlist heart: owned entirely by the global [data-wish] wiring in
       umai-wishlist.js (state + aria-pressed + pop animation). The old local
       aria-pressed flipper here double-fired against it, leaving the heart
       visually unsaved while the item WAS in storage — removed. */

    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-umai-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
